import { useEffect, useMemo, useState } from "react";

import { ICartInput, PRODUCT_SLUG, STATUS } from "@types";
import homeApi from "@features/home/helpers/homeApi";

import { useUI } from "@context/ui-managed-context";
import { useLayoutContext } from "@context/layout";
import { PRODUCT_SLUGS } from "../helpers/constants/constants";
import { IHomeCardsInput } from "@features/home/helpers/types";

export const useAllProduct = () => {
  const { userData } = useLayoutContext();
  const { openAlert, setAlertView } = useUI();

  const filterProducts = (products: ICartInput[] = []) =>
    products.filter(
      (item) => item.status === STATUS.PUBLISHED && item.price !== 0
    );
  const [userProducts, setUserProducts] = useState<IHomeCardsInput[]>();

  const isLogin = Boolean(userData?.is_login);

  const fetchUserProducts = async () => {
    if (!isLogin) return;
    try {
      const responses = await Promise.all(
        PRODUCT_SLUGS.map((slug) => homeApi.getHomeCards(slug).fetch())
      );

      const normalized = responses.map((item) => {
        if (!item.status) return item;

        return {
          ...item,
          data: {
            ...item.data,
            products: filterProducts(item.data?.products),
          },
        };
      });

      setUserProducts(normalized);
    } catch (error: any) {
      setAlertView("ALERT", [
        {
          mode: "danger",
          textBody: error?.error?.message || "Something went wrong",
        },
      ]);
      openAlert();
    }
  };

  useEffect(() => {
    fetchUserProducts();
  }, [userData]);

  const productMap = useMemo(() => {
    if (!userProducts) return {};

    return userProducts.reduce<Record<string, IHomeCardsInput>>((acc, item) => {
      const slug = item?.data?.slug;
      if (slug) acc[slug] = item;
      return acc;
    }, {});
  }, [userProducts]);

  const recommended = productMap[PRODUCT_SLUG.USER_RECOMMENDED_PRODUCTS];
  const favorite = productMap[PRODUCT_SLUG.USER_FAVORITE_PRODUCTS];
  const recent = productMap[PRODUCT_SLUG.USER_RECENT_VIEW_PRODUCT];

  const hasProducts = (item?: IHomeCardsInput) =>
    Boolean(item?.data?.products?.length);

  return {
    hasProducts,
    recommended,
    recent,
    favorite,
    isLogin,
  };
};
